import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_REQUIRE_TYPES, GET_REQUIRE_TYPES_SUCCESS, GET_REQUIRE_TYPES_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getRequireTypes({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/request-types`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_REQUIRE_TYPES_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_REQUIRE_TYPES_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_REQUIRE_TYPES_ERROR, payload: error });
  }
}

export function* watchGetRequireTypes() {
  yield takeEvery(GET_REQUIRE_TYPES, getRequireTypes);
}

function* getRequireTypesSaga() {
  yield all([fork(watchGetRequireTypes)]);
}

export default getRequireTypesSaga;